export default __webpack_public_path__ + "assets/images/shield_success.png";